"use strict";

function ActivityFilter() {
  const searchFields = ["activityName", "fullAddress"];
  let outreachTypeFormOptions;
  let activityGroupFormOptions;

  async function filterResourceDataHandler(unfilteredData, filters, loadingScreen, smartFilters) {
    return filterOffline(unfilteredData, filters, smartFilters);
  }

  function filterOffline(unfilteredData, filters, smartFilters) {
    return smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;
  }

  var getFilterConfigs = function () {
    return {
      activityAudience: ["targetOptions", "array"],
      activityStaff: ["targetOptions", "array"],
      activityPollutant: ["targetOptions", "array"],
      activityBehavior: ["targetOptions", "array"],
      drainsToRw: (datum, filters) => _nullIsAllFilter(datum.receivingWater, filters.drainsToRw),
      subGroups: (datum, filters) => _nullIsAllFilter(datum.progeny, filters.subGroups, parseInt),
      audienceType: "audienceType",
      outreachType: _outreachTypeFilter,
      activityGroup: _activityGroupFilter,
      activity: "activityKey",
      permits: "permit",
      date: _dateFilter,
      attendeeCount: passAttendeeCountFilter,
      impressionCount: passImpressionCountFilter,
      volunteerCount: passVolunteerCountFilter,
      otherFilters: (datum, filters) => {
        return ResourceFilters.passSearchStringFilter(datum, filters, searchFields);
      },
    };
  };

  function getOutreachOptions(activities) {
    if (outreachTypeFormOptions) {
      return outreachTypeFormOptions;
    }

    outreachTypeFormOptions = new GroupedFormOptions();

    for (const activity in activities) {
      const displayName = activities[activity].outreachType;
      outreachTypeFormOptions.add(displayName, activity);
    }

    return outreachTypeFormOptions;
  }

  function getActivityGroupOptions(activities) {
    if (activityGroupFormOptions) {
      return activityGroupFormOptions;
    }

    activityGroupFormOptions = new GroupedFormOptions();

    for (const activity in activities) {
      const displayName = activities[activity].activityGroup;
      activityGroupFormOptions.add(displayName, activity);
    }

    return activityGroupFormOptions;
  }

  function _outreachTypeFilter(datum, filters) {
    if (!filters.outreachType) {
      return true;
    }

    return filters.outreachType.some(function (outreachTypeIndex) {
      return outreachTypeFormOptions.has(outreachTypeIndex, datum.activityKey);
    });
  }

  function _activityGroupFilter(datum, filters) {
    if (!filters.activityGroup) {
      return true;
    }

    return filters.activityGroup.some(function (activityGroupIndex) {
      return activityGroupFormOptions.has(activityGroupIndex, datum.activityKey);
    });
  }

  function getActivityOptions(activities) {
    const options = [];

    for (const activity in activities) {
      options.push({
        name: activities[activity].displayName,
        value: activity,
      });
    }

    return options;
  }

  function _dateFilter(datum, filters) {
    return ResourceFilters.passDateRangeOverRangeFilter(
      datum.startDateIso,
      datum.endDateIso,
      filters.date?.from,
      filters.date?.to,
    );
  }

  function passAttendeeCountFilter(datum, filters) {
    return OfflineFilterFunctions.passMinMaxFilter(datum.attendeeCount, filters.attendeeCount);
  }

  function passImpressionCountFilter(datum, filters) {
    return OfflineFilterFunctions.passMinMaxFilter(datum.impressionCount, filters.impressionCount);
  }

  function passVolunteerCountFilter(datum, filters) {
    return OfflineFilterFunctions.passMinMaxFilter(datum.volunteerCount, filters.volunteerCount);
  }

  function _nullIsAllFilter(value, filter, filterTransformCallback = null) {
    if (!filter) {
      return true;
    } else if (value === undefined) {
      return false;
    }

    return filter.some(function (filterValue) {
      if (value === null) {
        return true;
      } else if (filterTransformCallback !== null) {
        filterValue = filterTransformCallback(filterValue);
      }

      return value.includes(filterValue);
    });
  }

  return {
    filterResourceDataHandler,
    getFilterConfigs,
    getOutreachTypeOptions: getOutreachOptions,
    getActivityGroupFilterOptions: getActivityGroupOptions,
    getActivityFilterOptions: getActivityOptions,
    _nullIsAllFilter,
  };
}

module.exports = ActivityFilter();

const ResourceFilters = require("../filters/resourceFilters");
const GroupedFormOptions = require("../general/groupedFormOptions");
const OfflineFilterFunctions = require("../mapFunctions/offlineFilterFunctions");
